/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Internalization constants for AccountSelect component
 *
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.2.0
 */

import IAccountSelectTranslation from '../../types/common/accountSelect';

const initTranslationAccountSelect: IAccountSelectTranslation = {
    account: '',
    balance: '',
    name: '',
    notFound: '',
};

export default initTranslationAccountSelect;
